import { get } from '.';

export const getClients = () => get(`/api/clients`);

export const getClient = ({ queryKey }) => get(`/api/clients/${queryKey[1]}`);
